import { User } from '../../user/User.interface';
import { JiraFieldConfig } from '../jira-server/jira-server.interface';
import { Task } from '../tasks/Task.interface';

export interface CapaConfig {
  visibleJiraFields?: JiraFieldConfig[];
}

export enum CapaSource {
  InternalAudit = 'Internal Audit',
  ExternalAudit = 'External Audit',
  Deviation = 'Deviation',
  Other = 'Other'
}

export const CapaSeverityText = [
  'Not Severe',
  'Annoyance',
  'Moderate Severity',
  'Potentially Compromised',
  'Highest Severity'
];

export const CapaProbabilityText = [
  'Almost Never',
  'Hardly Ever',
  'Sometimes',
  'Usually',
  'All The Time'
];

export enum CapaProbability {
  AlmostNever = 1,
  HardlyEver,
  Sometimes,
  Usually,
  AllTheTime
}

export enum CapaSeverity {
  NotSevere = 1,
  Annoyance,
  ModerateSeverity,
  PotentiallyCompromised,
  HighestSeverity
}

export enum CapaRootCause {
  Man = 'Man',
  Machine = 'Machines',
  Material = 'Material',
  Method = 'Method',
  Medium = 'Medium'
}

export enum CapaStatus {
  New = 'New',
  Investigation = 'Investigation',
  InvestigationComplete = 'Investigation Complete',
  Implementation = 'Implementation',
  ImplementationComplete = 'Implementation Complete',
  CAPAVerified = 'CAPA Verified',
  Closed = 'Closed'
}

export interface Capa {
  id: number;
  taskId: number;
  task: Task;
  title: string;
  summary: string;
  source: CapaSource;
  sourceReference?: string;
  description?: string;
  capaOwner?: User;
  severity: CapaSeverity;
  probability: CapaProbability;
  risk?: number;
  correctiveActions: string;
  investigator?: User;
  rootCause?: CapaRootCause;
  rootCauseRationale?: string;
  preventiveAction?: string;
  trainingNeeded?: boolean | 1 | 0;
  verification?: string;
  capaStatus?: CapaStatus;
  createdBy?: User;
  modifiedBy?: User;
  created?: Date;
  modified?: Date;
  deleted: boolean;
}

export interface CapaStat {
  status: string;
  date: string;
  value: number;
}
export interface BaseCapaCardProps {
  capa: Capa;
  onChange: (capa: Partial<Capa>) => void;
  setSuccessMessage: (message: string) => void;
  setErrorMessage: (message: string) => void;
}
